/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Datatable} from '../../../components/Datatable/Datatable'
import {Button} from '../../../components/Button/Button'
import {useNavigate} from 'react-router-dom'
import {DELETE, GET, PATCH, POST, PUT} from '../../../services/api'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {Loading} from '../../../components/Loading/Loading'
import {i18n} from '../../../translate/i18n'
import Swal from 'sweetalert2'
import useModals from '../../../hooks/useModals'
import {ModalDelete} from '../../../components/Modals/General/ModalDelete/ModalDelete'
import {useSwitchStatus} from '../../../components/Datatable/SwitchStatus'

type Cupons = {
  id: number
  nameCoupom: string
  description: null
  typeCupom: string
  pluginspaceId: number
  valueDiscount: string
  percentageDiscount: string
  usageQuantity: number
  startDate: string
  endDate: string
  created: string
  updated: string
  deleted: null
  status: boolean
  idCatalog?: number | null
  sellerId?: number | null
}

const CoupomContent: FC = () => {
  const navigate = useNavigate()
  const [idCouponDelete, setIdCouponDelete] = useState<number>(0)
  const [loading, setLoading] = useState(false)
  const [cupons, setCupons] = useState<Cupons[]>([])
  const {showDeleteModal} = useModals()
  const {switchStatus} = useSwitchStatus()

  async function deleteCoupons() {
    try {
      if (!idCouponDelete) {
        Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: 'Erro ao deletar cupom!',
        })

        return
      }
      setLoading(true)

      const response = await DELETE(`/discount-coupons/deleteCoupons/${idCouponDelete}`)

      setLoading(false)
      if (!response || !response.success) {
        Swal.fire({
          icon: 'warning',
          title: 'Oops...',
          text: 'Erro ao deletar cupom!',
        })
        return
      }
      Swal.fire({
        icon: 'success',
        title: 'Sucesso',
        text: 'Cupom deletado com sucesso!',
      }).then(async () => await loadCupons())
    } catch (error) {
      setLoading(false)
      Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'Erro ao deletar cupom!',
      })
    }
  }

  // const switchStatus = async (Id: number, status: boolean) => {
  //   try {
  //     const cupomBody = {
  //       id: Id,
  //       status: !status,
  //     }
  //     const switchCupom = await PATCH('/discount-coupons/updateCoupons', cupomBody)

  //     if (switchCupom.success) {
  //       const newCupons = cupons.map((cupom: any) => {
  //         if (cupom.id === Id) {
  //           cupom.status = !status
  //         }
  //         return cupom
  //       })
  //       setCupons(newCupons)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //   }
  // }

  function translateTypeCupom(typeCupom: string) {
    switch (typeCupom) {
      case 'classification':
        return 'Classificativo'
      case 'product':
        return 'Produtos'
      case 'individuality':
        return 'Individual'
      case 'exclusive':
        return 'Exclusivo'
      case 'periodical':
        return 'Periódico'
      case 'quantitative':
        return 'Quantitativo'
      case 'cupomDay':
        return 'Do Dia'
      default:
        return 'Classificativo'
    }
  }

  async function loadCupons() {
    setLoading(true)
    try {
      const response = await POST('/discount-coupons/filterCoupons')
      if (response.success) {
        if (response.data) {
          setCupons(
            response.data
              .filter((cupom: Cupons) => !cupom.deleted)
              .map((cupom: Cupons) => {
                return {
                  id: cupom.id,
                  typeCupom: translateTypeCupom(cupom.typeCupom),
                  nameCoupom: cupom.nameCoupom,
                  status: cupom.status,
                  dataInicio: new Date(cupom.startDate).toLocaleDateString('pt-br'),
                  dataFim: new Date(cupom.endDate).toLocaleDateString('pt-br'),
                  description: cupom.description,
                  valueDiscount: cupom.valueDiscount,
                  percentageDiscount: cupom.percentageDiscount,
                  usageQuantity: cupom.usageQuantity,
                  created: cupom.created,
                  updated: cupom.updated,
                  deleted: cupom.deleted,
                  idCatalog: cupom.idCatalog,
                  sellerId: cupom.sellerId,
                }
              })
          )
          return null
        }
        setCupons([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadCupons()
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`coupons.title`)}</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>{i18n.t(`coupons.subTitle`)}</span>
              </h3>
              <div className='d-flex justify-content-center align-items-end'>
                <Button
                  text={i18n.t(`coupons.create`)}
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => navigate('/coupons/create')}
                  btnClass='mb-0 fw-bolder'
                />
              </div>
            </div>
            <div className='card-body'>
              <Datatable
                data={cupons}
                headers={[
                  {key: 'Nome', value: 'nameCoupom', type: 'default'},
                  {key: 'Data Início', value: 'dataInicio', type: 'default'},
                  {key: 'Data Fim', value: 'dataFim', type: 'default'},
                  {key: 'Tipo', value: 'typeCupom', type: 'default'},
                  {
                    key: 'Status',
                    value: 'status',
                    type: 'check',
                    action: (item: any) =>
                      switchStatus({
                        endpoint: 'discount-coupons/updateCoupons',
                        Id: item.id,
                        status: item.status,
                        method: 'PATCH',
                      }),
                    // action: (item: any) => switchStatus(item.id, item.status),
                  },
                  {key: 'Ações', value: 'acoes', type: ''},
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    action: (item) => {
                      navigate(`/coupons/edit/${item.id}`)
                    },
                    title: 'Editar',
                  } /*
                    {
                      icon: 'fas fa-trash',
                      action: (item) => {
                        showDeleteModal('Excluir Recurso')
                        setIdCouponDelete(item.id)
                      },
                      path: '',
                      title: 'Excluir Recurso',
                    },*/,
                ]}
                color='primary'
              />
            </div>
          </div>
        </div>
      )}
      <ModalDelete confirmAction={() => deleteCoupons()} />
    </>
  )
}

const CouponsPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[{title: 'Cupons', path: 'coupons', isActive: true}]}>
        Cupons
      </PageTitle>
      <CoupomContent />
    </>
  )
}

export {CouponsPage}
